import { Star } from 'lucide-react';

import { Toggle } from '@/components/shadcn/ui/toggle';
import { cn } from '@/lib/cn';
import { useSignalsSearchParams } from '@/pages/workspace/signals/search-params-schema';

export default function FavoriteToggle() {
  const [params, setParams] = useSignalsSearchParams();

  const isFavoriteActive = params.favorite;

  return (
    <Toggle
      variant="outline"
      size="default"
      pressed={isFavoriteActive}
      onPressedChange={(pressed) => {
        setParams({
          favorite: pressed,
        });
      }}
      aria-label="Toggle favorite filter"
    >
      <Star
        className={cn([
          'size-4 text-gray-700 fill-none',
          {
            'text-yellow-500 fill-yellow-500': isFavoriteActive,
          },
        ])}
      />
    </Toggle>
  );
}
